/**
 * Calcul centralisé des totaux commande (partner discount dynamique).
 * Aligné sur le pattern toys-request / n8n.
 */

import { normalizeConfig } from "./normalizeConfig";

export function getEffectivePartnerDiscountRate(config) {
  const c = normalizeConfig(config);
  if (!c || !c.applyPartnerDiscount) return 0;
  const r = c.partnerCommissionRate;
  if (typeof r === "number" && !Number.isNaN(r) && r > 0) return r;
  const d = c.discount;
  if (typeof d === "number" && !Number.isNaN(d) && d > 0) return d;
  return 0;
}

/**
 * @param {object} config  Config partenaire (brute ou normalisée)
 * @param {number} totalItemPriceTTC  Somme TTC des lignes du panier
 * @param {number} totalItemPriceHT   Somme HT des lignes du panier
 * @returns {{ deliveryFee: number, totalDiscount: number, totalPriceDisplay: number, totalPriceHT: number, partnerCommissionPercent: number|undefined }}
 */
export function computeOrderTotals(config, totalItemPriceTTC, totalItemPriceHT) {
  const c = normalizeConfig(config);

  let deliveryFee = 0;
  if (c.applyDeliveryFee) {
    deliveryFee =
      c.deliveryFreeThreshold > 0 &&
      totalItemPriceTTC >= c.deliveryFreeThreshold
        ? 0
        : c.deliveryCost;
  }

  let totalDiscount = 0;
  if (c.applyPartnerDiscount) {
    const rate = getEffectivePartnerDiscountRate(c);
    // Partner discount applies to items + delivery fee (when applicable).
    totalDiscount = (totalItemPriceTTC + deliveryFee) * rate;
  }

  const totalPriceDisplay = totalItemPriceTTC + deliveryFee - totalDiscount;
  const totalPriceHT = totalItemPriceHT + deliveryFee / 1.2 - totalDiscount;

  const rate = getEffectivePartnerDiscountRate(c);
  const partnerCommissionPercent =
    c.applyPartnerDiscount && rate > 0
      ? c.partnerCommissionPercent != null
        ? Number(c.partnerCommissionPercent)
        : Math.round(rate * 100)
      : undefined;

  return {
    deliveryFee,
    totalDiscount,
    totalPriceDisplay,
    totalPriceHT,
    partnerCommissionPercent,
  };
}
